"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeletedNotificationSnackback = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _TranslationKey = require("../models/TranslationKey");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const AUTOHIDE_AFTER_MS = 5000; // 5 seconds;

const SnackbarContentSuccess = (0, _mui.styled)(_mui.SnackbarContent)(({
  theme
}) => ({
  padding: 0,
  minHeight: theme.spacing(10),
  flexWrap: 'nowrap',
  [theme.breakpoints.up('sm')]: {
    width: theme.spacing(66)
  },
  backgroundColor: theme.palette.grey[700]
}));
const Message = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold',
  padding: theme.spacing(1, 2)
}));
const SnackbarContentError = (0, _mui.styled)(SnackbarContentSuccess)(({
  theme
}) => ({
  backgroundColor: theme.palette.error.main
}));
const createIconStyled = theme => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  padding: theme.spacing(0, 2, 0, 0),
  alignSelf: 'baseline'
});
const InfoOutlinedIcon = (0, _mui.styled)(_icons.InfoCircle)(({
  theme
}) => createIconStyled(theme));
const CheckRoundIcon = (0, _mui.styled)(_icons.CheckCircle)(({
  theme
}) => createIconStyled(theme));
const CustomButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  display: 'block',
  height: '100%',
  minHeight: theme.spacing(10),
  minWidth: theme.spacing(20),
  margin: '0 8px 0 0',
  padding: theme.spacing(2, 4, 2, 4),
  textTransform: 'none',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[300]
  }
}));
const DeletedNotificationSnackback = ({
  deletedNotification,
  onRequestClose,
  onRestore
}) => {
  const onCloseHandler = (0, _react.useCallback)((_, reason) => {
    if (reason === 'timeout') {
      onRequestClose();
    }
  }, [onRequestClose]);
  const handleRestore = (0, _react.useCallback)(() => {
    void onRestore();
  }, [onRestore]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Snackbar, {
    open: true,
    autoHideDuration: AUTOHIDE_AFTER_MS,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    onClose: onCloseHandler,
    children: deletedNotification === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SnackbarContentError, {
      message: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Message, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(InfoOutlinedIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: _TranslationKey.TranslationKey.DeleteFailed
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(SnackbarContentSuccess, {
      message: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Message, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CheckRoundIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: _TranslationKey.TranslationKey.NotificationDeleted
        })]
      }),
      action: /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomButton, {
        variant: "text",
        onClick: handleRestore,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: _TranslationKey.TranslationKey.Undo
        })
      })
    })
  }, deletedNotification === false ? 'error' : deletedNotification.notificationId ?? '');
};
exports.DeletedNotificationSnackback = DeletedNotificationSnackback;
